<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.home')"
      >Perfil de {{ studentProfile.student.name }}</back-profile
    >

    <!-- Active alerts -->
    <block>
      <template slot="header"
        >Notas</template
      >
      <div class="grades">
        <div class="term-grades" v-for="t in reversedTerms" :key="t.id">
          <div class="term">{{ t.name }}</div>
          <term-grades-table
            :snapshots="snapshots"
            :grades="gradesByTerm[t.id]"
            :gradeThreshold="settings.deficientGradeThreshold"
          ></term-grades-table>
        </div>
      </div>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"
import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"
import TermGradesTable from "./TermGradesTable.vue"

export default {
  name: "ProfileGrades",
  props: {
    studentId: {
      type: String
    }
  },
  data() {
    return {
      studentProfile: {
        student: {
          name: ""
        }
      },
      terms: [],
      studentGrades: {
        coursesGrades: []
      },
      settings: {
        deficientGradeThreshold: 3.0
      }
    }
  },
  apollo: {
    terms: gql`
      query Terms {
        terms {
          id
          name
        }
      }
    `,
    studentProfile: {
      query: gql`
        query StudentProfile($studentId: ID!) {
          studentProfile(studentId: $studentId) {
            student {
              id
              name
              enrolledSince {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    },
    studentGrades: {
      query: gql`
        query StudentGrades($studentId: ID!) {
          studentGrades(studentId: $studentId) {
            coursesGrades {
              term {
                id
              }
              courseCode
              courseName
              snapshot
              isFinal
              isActive
              grade {
                grade
              }
              status
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    },
    settings: {
      query: gql`
        query {
          settings {
            deficientGradeThreshold
          }
        }
      `
    }
  },
  computed: {
    snapshots() {
      if (this.studentGrades.coursesGrades.length == 0) {
        // ensure minumum
        return 3
      }
      const snapshots = this.studentGrades.coursesGrades.map(g => g.snapshot)
      return Math.max(...snapshots)
    },

    gradesByTerm() {
      const grades_by_term = {}

      // First, fill up with terms
      this.terms.forEach(term => {
        grades_by_term[term.id] = []
      })

      // Now, group all grades
      this.studentGrades.coursesGrades.forEach(g => {
        grades_by_term[g.term.id].push(g)
      })

      return grades_by_term
    },

    reversedTerms() {
      if (
        this.studentProfile.student.enrolledSince &&
        this.studentProfile.student.enrolledSince.name
      ) {
        let cutIndex = this.terms.findIndex(item => {
          return item.name === this.studentProfile.student.enrolledSince.name
        })
        return [...this.terms.slice(cutIndex)]
          .reverse()
          .filter(term => this.gradesByTerm[term.id].length > 0)
      } else {
        return [...this.terms].reverse().filter(term => this.gradesByTerm[term.id].length > 0)
      }
    },

    normalizedGrades() {
      const data = []

      // Now, group

      const item = {
        term_name: "2018-2",
        grades: [
          {
            course_code: "A",
            course_name: "B",
            snapshots: [null, null, 3.4],
            final: 1.4
          }
        ]
      }

      data.push(item)

      return data
    }
  },
  components: {
    Block,
    BackProfile,
    TermGradesTable
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    }
  }
}
</script>

<style scoped>
.comments {
  margin-bottom: 10px;
}

.comment {
  margin-bottom: 20px;
}
</style>
